export const CONTRACT_ADDRESS = "GjJsyLWFEHA4TCJBGpobM2tceM4wiQaD3ZPKDhDppump";
export const BUY_URL = "https://pump.fun/coin/GjJsyLWFEHA4TCJBGpobM2tceM4wiQaD3ZPKDhDppump";
export const X_URL = "https://x.com/i/communities/1991446771692687827";
export const TICKER = "$Cyclospora";

export const BG_IMAGE = "https://customer-assets.emergentagent.com/job_25981c14-2075-47d7-bac8-a083cce39fe1/artifacts/norrj7w8_C44650C7-2077-4A77-A28F-1E1291BCDC68.png";
export const STYLE_REF_1 = "https://customer-assets.emergentagent.com/job_25981c14-2075-47d7-bac8-a083cce39fe1/artifacts/htb3wb4j_IMG_7631.jpeg";
export const STYLE_REF_2 = "https://customer-assets.emergentagent.com/job_25981c14-2075-47d7-bac8-a083cce39fe1/artifacts/6138thr1_IMG_7630.jpeg";

// generated assets (checkerboard removed -> served from /public/assets)
export const MASCOT_IMG = "/assets/logo.png";
export const TP_IMG = "/assets/tp.png";

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    /* fall through to legacy */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}
